export default {
  ownershipOptions: [
    { label: 'Privately Owned', value: 'private' },
    { label: 'Publicly Listed', value: 'listed' },
    { label: 'Unlisted Public Limited Company', value: 'plc' },
    { label: 'Cooperative', value: 'co-op' },
    { label: 'State-Owned', value: 'government' },
    { label: 'Other', value: 'other' },
  ],
  currencyOptions: [
    { code: 'USD' },
    { code: 'GBP' },
    { code: 'EUR' },
    { code: 'AOA' },
    { code: 'JPY' },
    { code: 'BIF' },
    { code: 'BWP' },
    { code: 'CDF' },
    { code: 'CVE' },
    { code: 'DJF' },
    { code: 'DZD' },
    { code: 'EGP' },
    { code: 'ERN' },
    { code: 'ETB' },
    { code: 'GMD' },
    { code: 'GHS' },
    { code: 'GNF' },
    { code: 'KES' },
    { code: 'KMF' },
    { code: 'LRD' },
    { code: 'LSL' },
    { code: 'LYD' },
    { code: 'MAD' },
    { code: 'MGA' },
    { code: 'MRU' },
    { code: 'MUR' },
    { code: 'MWK' },
    { code: 'MZN' },
    { code: 'NAD' },
    { code: 'NGN' },
    { code: 'RWF' },
    { code: 'STN' },
    { code: 'SCR' },
    { code: 'SDG' },
    { code: 'SLL' },
    { code: 'SOS' },
    { code: 'SSP' },
    { code: 'SZL' },
    { code: 'TZS' },
    { code: 'TND' },
    { code: 'UGX' },
    { code: 'XAF' },
    { code: 'XOF' },
    { code: 'ZAR' },
    { code: 'ZMW' },
    { code: 'ZWD' },
  ],
  sectorOptions: [
    { name: 'Agriculture' },
    { name: 'Construction' },
    { name: 'Consumer goods' },
    { name: 'Education' },
    { name: 'Financial Services' },
    { name: 'Food and beverages' },
    { name: 'Governmental Institutions' },
    { name: 'Health care' },
    { name: 'Industrial Manufacturing' },
    { name: 'Information technology' },
    { name: 'Leisure and tourism' },
    { name: 'Media' },
    { name: 'Mining and metals' },
    { name: 'Oil and Gas' },
    { name: 'Power and utilities' },
    { name: 'Real estate' },
    { name: 'Retail' },
    { name: 'Services' },
    { name: 'Telecommunications' },
    { name: 'Transport' },
  ],
  businessSectorOptions: [
    { name: 'Academic' },
    { name: 'Advisory - Business Intelligence' },
    { name: 'Advisory - Financial' },
    { name: 'Advisory - Legal' },
    { name: 'Advisory - Management Consulting' },
    { name: 'Banking' },
    { name: 'Corporate - Manufacturing' },
    { name: 'Corporate - Wholesale & Retail' },
    { name: 'Corporate - Agriculture' },
    { name: 'Corporate - Health & Technology' },
    { name: 'Corporate - Other Services' },
    { name: 'Government' },
    { name: 'Insurance' },
    { name: 'Investment - Angel' },
    { name: 'Investment - Development Finance' },
    { name: 'Investment - Family Office ' },
    { name: 'Investment - Private Equity' },
    { name: 'Investment - Venture Capital' },
    { name: 'Non-Governmental Organization' },
  ],
  countryOptions: [
    { label: '', value: '5' },
    { label: 'Afghanistan', value: '6' },
    { label: 'Åland Islands', value: '7' },
    { label: 'Albania', value: '8' },
    { label: 'Algeria', value: '9' },
    { label: 'American Samoa', value: '10' },
    { label: 'Andorra', value: '11' },
    { label: 'Angola', value: '12' },
    { label: 'Anguilla', value: '13' },
    { label: 'Antarctica', value: '14' },
    { label: 'Antigua and Barbuda', value: '15' },
    { label: 'Argentina', value: '16' },
    { label: 'Armenia', value: '17' },
    { label: 'Aruba', value: '18' },
    { label: 'Australia', value: '19' },
    { label: 'Austria', value: '20' },
    { label: 'Azerbaijan', value: '21' },
    { label: 'Bahamas', value: '22' },
    { label: 'Bahrain', value: '23' },
    { label: 'Bangladesh', value: '24' },
    { label: 'Barbados', value: '25' },
    { label: 'Belarus', value: '26' },
    { label: 'Belgium', value: '27' },
    { label: 'Belize', value: '28' },
    { label: 'Benin', value: '29' },
    { label: 'Bermuda', value: '30' },
    { label: 'Bhutan', value: '31' },
    { label: 'Bolivia, Plurinational State of', value: '32' },
    { label: 'Bosnia and Herzegovina', value: '33' },
    { label: 'Botswana', value: '34' },
    { label: 'Bouvet Island', value: '35' },
    { label: 'Brazil', value: '36' },
    { label: 'British Indian Ocean Territory', value: '37' },
    { label: 'Brunei Darussalam', value: '38' },
    { label: 'Bulgaria', value: '39' },
    { label: 'Burkina Faso', value: '40' },
    { label: 'Burundi', value: '41' },
    { label: 'Cambodia', value: '42' },
    { label: 'Cameroon', value: '43' },
    { label: 'Canada', value: '44' },
    { label: 'Cape Verde', value: '45' },
    { label: 'Cayman Islands', value: '46' },
    { label: 'Central African Republic', value: '47' },
    { label: 'Chad', value: '48' },
    { label: 'Channel Islands', value: '49' },
    { label: 'Chile', value: '50' },
    { label: 'China', value: '51' },
    { label: 'Christmas Island', value: '52' },
    { label: 'Cocos (Keeling) Islands', value: '53' },
    { label: 'Colombia', value: '54' },
    { label: 'Comoros', value: '55' },
    { label: 'Congo, Republic of the', value: '56' },
    { label: 'Congo, the Democratic Republic of the', value: '57' },
    { label: 'Cook Islands', value: '58' },
    { label: 'Costa Rica', value: '59' },
    { label: "Côte d'Ivoire", value: '60' },
    { label: 'Croatia', value: '61' },
    { label: 'Cuba', value: '62' },
    { label: 'Cyprus', value: '63' },
    { label: 'Czech Republic', value: '64' },
    { label: 'Denmark', value: '65' },
    { label: 'Djibouti', value: '66' },
    { label: 'Dominica', value: '67' },
    { label: 'Dominican Republic', value: '68' },
    { label: 'Ecuador', value: '69' },
    { label: 'Egypt', value: '70' },
    { label: 'El Salvador', value: '71' },
    { label: 'Equatorial Guinea', value: '72' },
    { label: 'Eritrea', value: '73' },
    { label: 'Estonia', value: '74' },
    { label: 'Ethiopia', value: '75' },
    { label: 'Falkland Islands (Malvinas)', value: '76' },
    { label: 'Faroe Islands', value: '77' },
    { label: 'Fiji', value: '78' },
    { label: 'Finland', value: '79' },
    { label: 'France', value: '80' },
    { label: 'French Guiana', value: '81' },
    { label: 'French Polynesia', value: '82' },
    { label: 'French Southern Territories', value: '83' },
    { label: 'Gabon', value: '84' },
    { label: 'Georgia', value: '86' },
    { label: 'Germany', value: '87' },
    { label: 'Ghana', value: '88' },
    { label: 'Gibraltar', value: '89' },
    { label: 'Greece', value: '90' },
    { label: 'Greenland', value: '91' },
    { label: 'Grenada', value: '92' },
    { label: 'Guadeloupe', value: '93' },
    { label: 'Guam', value: '94' },
    { label: 'Guatemala', value: '95' },
    { label: 'Guernsey', value: '96' },
    { label: 'Guinea', value: '97' },
    { label: 'Guinea-Bissau', value: '98' },
    { label: 'Guyana', value: '99' },
    { label: 'Haiti', value: '100' },
    { label: 'Heard Island and McDonald Islands', value: '101' },
    { label: 'Holy See (Vatican City State)', value: '102' },
    { label: 'Honduras', value: '103' },
    { label: 'Hong Kong', value: '104' },
    { label: 'Hungary', value: '105' },
    { label: 'Iceland', value: '106' },
    { label: 'India', value: '107' },
    { label: 'Indonesia', value: '108' },
    { label: 'Iran, Islamic Republic of', value: '109' },
    { label: 'Iraq', value: '110' },
    { label: 'Ireland', value: '111' },
    { label: 'Isle of Man', value: '112' },
    { label: 'Israel', value: '113' },
    { label: 'Italy', value: '114' },
    { label: 'Jamaica', value: '115' },
    { label: 'Japan', value: '116' },
    { label: 'Jersey', value: '117' },
    { label: 'Jordan', value: '118' },
    { label: 'Kazakhstan', value: '119' },
    { label: 'Kenya', value: '120' },
    { label: 'Kiribati', value: '121' },
    { label: "Korea, Democratic People's Republic of", value: '122' },
    { label: 'Korea, Republic of', value: '123' },
    { label: 'Kuwait', value: '124' },
    { label: 'Kyrgyzstan', value: '125' },
    { label: "Lao People's Democratic Republic", value: '126' },
    { label: 'Latvia', value: '127' },
    { label: 'Lebanon', value: '128' },
    { label: 'Lesotho', value: '129' },
    { label: 'Liberia', value: '130' },
    { label: 'Libya', value: '131' },
    { label: 'Liechtenstein', value: '132' },
    { label: 'Lithuania', value: '133' },
    { label: 'Luxembourg', value: '134' },
    { label: 'Macao', value: '135' },
    { label: 'Macedonia, the former Yugoslav Republic of', value: '136' },
    { label: 'Madagascar', value: '137' },
    { label: 'Malawi', value: '138' },
    { label: 'Malaysia', value: '139' },
    { label: 'Maldives', value: '140' },
    { label: 'Mali', value: '141' },
    { label: 'Malta', value: '142' },
    { label: 'Marshall Islands', value: '143' },
    { label: 'Martinique', value: '144' },
    { label: 'Mauritania', value: '145' },
    { label: 'Mauritius', value: '146' },
    { label: 'Mayotte', value: '147' },
    { label: 'Mexico', value: '148' },
    { label: 'Micronesia, Federated States of', value: '149' },
    { label: 'Moldova, Republic of', value: '150' },
    { label: 'Monaco', value: '151' },
    { label: 'Mongolia', value: '152' },
    { label: 'Montenegro', value: '153' },
    { label: 'Montserrat', value: '154' },
    { label: 'Morocco', value: '155' },
    { label: 'Mozambique', value: '156' },
    { label: 'Myanmar', value: '157' },
    { label: 'Namibia', value: '158' },
    { label: 'Nauru', value: '159' },
    { label: 'Nepal', value: '160' },
    { label: 'Netherlands', value: '161' },
    { label: 'Netherlands Antilles', value: '162' },
    { label: 'New Caledonia', value: '163' },
    { label: 'New Zealand', value: '164' },
    { label: 'Nicaragua', value: '165' },
    { label: 'Niger', value: '166' },
    { label: 'Nigeria', value: '167' },
    { label: 'Niue', value: '168' },
    { label: 'Norfolk Island', value: '169' },
    { label: 'Northern Mariana Islands', value: '170' },
    { label: 'Norway', value: '171' },
    { label: 'Oman', value: '172' },
    { label: 'Pakistan', value: '173' },
    { label: 'Palau', value: '174' },
    { label: 'Palestinian Territory, Occupied', value: '175' },
    { label: 'Panama', value: '176' },
    { label: 'Papua New Guinea', value: '177' },
    { label: 'Paraguay', value: '178' },
    { label: 'Peru', value: '179' },
    { label: 'Philippines', value: '180' },
    { label: 'Pitcairn', value: '181' },
    { label: 'Poland', value: '182' },
    { label: 'Portugal', value: '183' },
    { label: 'Puerto Rico', value: '184' },
    { label: 'Qatar', value: '185' },
    { label: 'Réunion', value: '186' },
    { label: 'Romania', value: '187' },
    { label: 'Russian Federation', value: '188' },
    { label: 'Rwanda', value: '189' },
    { label: 'Saint Barthélemy', value: '190' },
    { label: 'Saint Helena, Ascension and Tristan da Cunha', value: '191' },
    { label: 'Saint Kitts and Nevis', value: '192' },
    { label: 'Saint Lucia', value: '193' },
    { label: 'Saint Martin (French part)', value: '194' },
    { label: 'Saint Pierre and Miquelon', value: '195' },
    { label: 'Saint Vincent and the Grenadines', value: '196' },
    { label: 'Samoa', value: '197' },
    { label: 'San Marino', value: '198' },
    { label: 'Sao Tome and Principe', value: '199' },
    { label: 'Saudi Arabia', value: '200' },
    { label: 'Senegal', value: '201' },
    { label: 'Serbia', value: '202' },
    { label: 'Seychelles', value: '203' },
    { label: 'Sierra Leone', value: '204' },
    { label: 'Singapore', value: '205' },
    { label: 'Slovakia', value: '206' },
    { label: 'Slovenia', value: '207' },
    { label: 'Solomon Islands', value: '208' },
    { label: 'Somalia', value: '209' },
    { label: 'South Africa', value: '210' },
    { label: 'South Georgia and the South Sandwich Islands', value: '211' },
    { label: 'South Sudan', value: '212' },
    { label: 'Spain', value: '213' },
    { label: 'Sri Lanka', value: '214' },
    { label: 'Sudan', value: '215' },
    { label: 'Suriname', value: '216' },
    { label: 'Svalbard and Jan Mayen', value: '217' },
    { label: 'Swaziland', value: '218' },
    { label: 'Sweden', value: '219' },
    { label: 'Switzerland', value: '220' },
    { label: 'Syrian Arab Republic', value: '221' },
    { label: 'Taiwan, Province of China', value: '222' },
    { label: 'Tajikistan', value: '223' },
    { label: 'Tanzania', value: '224' },
    { label: 'Thailand', value: '225' },
    { label: 'The Gambia', value: '85' },
    { label: 'Timor-Leste', value: '226' },
    { label: 'Togo', value: '227' },
    { label: 'Tokelau', value: '228' },
    { label: 'Tonga', value: '229' },
    { label: 'Trinidad and Tobago', value: '230' },
    { label: 'Tunisia', value: '231' },
    { label: 'Turkey', value: '232' },
    { label: 'Turkmenistan', value: '233' },
    { label: 'Turks and Caicos Islands', value: '234' },
    { label: 'Tuvalu', value: '235' },
    { label: 'Uganda', value: '236' },
    { label: 'Ukraine', value: '237' },
    { label: 'United Arab Emirates', value: '238' },
    { label: 'United Kingdom', value: '239' },
    { label: 'United States', value: '240' },
    { label: 'United States Minor Outlying Islands', value: '241' },
    { label: 'Uruguay', value: '242' },
    { label: 'Uzbekistan', value: '243' },
    { label: 'Vanuatu', value: '244' },
    { label: 'Venezuela, Bolivarian Republic of', value: '245' },
    { label: 'Viet Nam', value: '246' },
    { label: 'Virgin Islands, British', value: '247' },
    { label: 'Virgin Islands, U.S.', value: '248' },
    { label: 'Wallis and Futuna', value: '249' },
    { label: 'Western Sahara', value: '250' },
    { label: 'Yemen', value: '251' },
    { label: 'Zambia', value: '252' },
    { label: 'Zimbabwe', value: '253' },
  ],
  requestCountryNominationOptions: [
    { label: '', value: '5' },
    { label: 'Algeria', value: '9' },
    { label: 'Congo, Republic of the', value: '56' },
    { label: 'Congo, the Democratic Republic of the', value: '57' },
    { label: "Côte d'Ivoire", value: '60' },
    { label: 'Egypt', value: '70' },
    { label: 'Equatorial Guinea', value: '72' },
    { label: 'Ethiopia', value: '75' },
    { label: 'Gabon', value: '84' },
    { label: 'Ghana', value: '88' },
    { label: 'Kenya', value: '120' },
    { label: 'Liberia', value: '130' },
    { label: 'Libya', value: '131' },
    { label: 'Morocco', value: '155' },
    { label: 'Mozambique', value: '156' },
    { label: 'Nigeria', value: '167' },
    { label: 'Rwanda', value: '189' },
    { label: 'Senegal', value: '201' },
    { label: 'Sierra Leone', value: '204' },
    { label: 'South Africa', value: '210' },
    { label: 'Tanzania', value: '224' },
    { label: 'The Gambia', value: '85' },
    { label: 'Tunisia', value: '231' },
    { label: 'Uganda', value: '236' },
    { label: 'Zambia', value: '252' },
    { label: 'Zimbabwe', value: '253' },
  ],
  requestCountryOptions: [
    { label: '', value: '5' },
    { label: 'Egypt', value: '70' },
    { label: 'Ghana', value: '88' },
    { label: 'Kenya', value: '120' },
    { label: 'Mozambique', value: '156' },
    { label: 'Nigeria', value: '167' },
    { label: 'Rwanda', value: '189' },
    { label: 'Uganda', value: '236' },
    { label: 'Tanzania', value: '224' },
    { label: 'Zambia', value: '252' },
    { label: 'Zimbabwe', value: '253' },
  ],
  corpdocsCountryOptions: [
    {
      label: '',
      value: 5,
    },
    {
      label: 'Angola',
      value: '12',
    },
    // {
    //   label: 'Benin',
    //   value: '29',
    // },
    // {
    //   label: 'Botswana',
    //   value: '34',
    // },
    // {
    //   label: 'Burkina Faso',
    //   value: '40',
    // },
    {
      label: 'Cameroon',
      value: '43',
    },
    {
      label: 'Congo, Republic of the',
      value: '56',
    },
    {
      label: 'Congo, the Democratic Republic of the',
      value: '57',
    },
    {
      label: "Côte d'Ivoire",
      value: '60',
    },
    {
      label: 'Egypt',
      value: '70',
    },
    {
      label: 'Gabon',
      value: '84',
    },
    {
      label: 'Ghana',
      value: '88',
    },
    {
      label: 'Kenya',
      value: '120',
    },
    { label: 'Mauritius', value: '146' },
    { label: 'Morocco', value: '155' },
    // {
    //   label: 'Liberia',
    //   value: '130',
    // },
    {
      label: 'Mozambique',
      value: '156',
    },
    // {
    //   label: 'Namibia',
    //   value: '158',
    // },
    {
      label: 'Nigeria',
      value: '167',
    },
    {
      label: 'Rwanda',
      value: '189',
    },
    { label: 'Senegal', value: '201' },
    { label: 'South Africa', value: '210' },
    // {
    //   label: 'Swaziland',
    //   value: '218',
    // },
    {
      label: 'Tanzania',
      value: '224',
    },
    {
      label: 'Togo',
      value: '227',
    },
    {
      label: 'Uganda',
      value: '236',
    },
    {
      label: 'Zambia',
      value: '252',
    },
    {
      label: 'Zimbabwe',
      value: '253',
    },
  ],

  regionOptions: [
    { name: 'All Africa' },
    { name: 'North Africa' },
    { name: 'West Africa' },
    { name: 'East Africa' },
    { name: 'Southern Africa' },
    { name: 'Central Africa' },
  ],
  regionalFocus: [
    { name: 'North Africa', value: 'north' },
    { name: 'West Africa', value: 'west' },
    { name: 'East Africa', value: 'east' },
    { name: 'Southern Africa', value: 'south' },
    { name: 'Central Africa', value: 'center' },
  ],
  dealRanges: [
    { name: 'Under $1m', value: '00000_00001' },
    { name: '$1m - $5m', value: '00001_00005' },
    { name: '$5m - $20m', value: '00005_00020' },
    { name: '$20m - $100m', value: '00020_00100' },
    { name: 'Over $100m', value: '00100_99999' },
  ],
  referralOptions: [
    { name: 'Google' },
    { name: 'Email' },
    { name: 'LinkedIn' },
    { name: 'Twitter' },
    { name: 'Facebook' },
    { name: 'Word of Mouth' },
    { name: 'Event' },
    { name: 'Other' },
  ],
  revenueOptions: [
    { name: 'under $1m', value: '00000_00001' },
    { name: '$1m - $5m', value: '00001_00005' },
    { name: '$5m - $10m', value: '00005_00010' },
    { name: '$10m - $25m', value: '00010_00025' },
    { name: '$25m - $100m', value: '00025_00100' },
    { name: '$100m - $500m', value: '00100_00500' },
    { name: '$500m+', value: '00500_99999' },
  ],
  dealroomEvents: [],
  advisoryOptions: [
    { label: 'No Advisor, and none planned', value: 'none' },
    {
      label:
        'No Advisor, but seeking Advisory support and open to recommendations',
      value: 'seeking',
    },
    { label: 'Investment Advisor already retained', value: 'in_place' },
  ],
  debtOptions: [
    { label: 'Trade Finance', value: 'trade' },
    { label: 'Working Capital', value: 'capital' },
    { label: 'Corporate Debt', value: 'corp' },
    { label: 'Bridge Finance', value: 'bridge' },
    { label: 'Mezzanine', value: 'mezzanine' },
    { label: 'Other', value: 'other' },
  ],
  transactionTypeOptions: [
    { label: 'Trade', value: 'trade' },
    { label: 'Investment', value: 'investment' },
    { label: 'Other', value: 'other' },
  ],
  fundPurposeOptions: [
    { label: 'Growth/Expansion', value: 'growth' },
    { label: 'Greenfield Project', value: 'greenfield' },
    { label: 'Merger/Acquisition', value: 'merger' },
    { label: 'Refinancing', value: 'refinancing' },
    { label: 'Exit', value: 'exit' },
    { label: 'Trade Finance', value: 'trade' },
    { label: 'Working Capital', value: 'working' },
    { label: 'Other Purposes', value: 'other' },
  ],
  investorTypeOptions: [
    { label: 'Investment - Angel', value: 'angel' },
    { label: 'Investment - Development Finance', value: 'devfinance' },
    { label: 'Investment - Family Office', value: 'family-office' },
    { label: 'Investment - Private Equity', value: 'private-equity' },
    { label: 'Investment - Venture Capital', value: 'capital' },
    { label: 'Investment - Corporate', value: 'corporate' },
  ],
  researchTypeOptions: [
    { label: 'Value Chain', value: 'chain' },
    { label: 'Market Structure', value: 'structure' },
    { label: 'Market Sizing', value: 'sizing' },
    { label: 'Investment Opportunities', value: 'deals' },
  ],
  dealHistoryTypeOptions: [
    { label: 'Deal - Buyout', value: 'buyout' },
    { label: 'Deal - Equity stake', value: 'equity-stake' },
    { label: 'Deal - Merger', value: 'merger' },
    { label: 'Deal - Exit', value: 'exit' },
    { label: 'Deal - Debt financing', value: 'debt-financing' },
    { label: 'Deal - Debt and Equity', value: 'debt-equity' },
    { label: 'Deal - Mezzanine', value: 'mezzanine' },
    { label: 'Deal - Infrastructure', value: 'infrastructure' },
    {
      label: 'Deal - Private Investment in Public Company (PIPE)',
      value: 'pipe',
    },
    { label: 'Deal - Initial Public Offering', value: 'ipo' },
    { label: 'Deal - Delisting', value: 'delisting' },
  ],
  yesNoOptions: [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ],
  importExportOptions: [
    { label: 'Import', value: 'import' },
    { label: 'Export', value: 'export' },
  ],
  fundYearOptions: [
    { label: '2020', value: 2020 },
    { label: '2021', value: 2021 },
    { label: '2022', value: 2022 },
    { label: '2023', value: 2023 },
    { label: '2024', value: 2024 },
  ],
  monthOptions: [
    { label: 'January', value: '1' },
    { label: 'February', value: '2' },
    { label: 'March', value: '3' },
    { label: 'April', value: '4' },
    { label: 'May', value: '5' },
    { label: 'June', value: '6' },
    { label: 'July', value: '7' },
    { label: 'August', value: '8' },
    { label: 'September', value: '9' },
    { label: 'October', value: '10' },
    { label: 'November', value: '11' },
    { label: 'December', value: '12' },
  ],
  projectTypesOptions: [
    { label: 'All', value: '' },
    { label: 'Corporate Documents', value: 'corpRegistryFiling' },
    { label: 'Custom Research', value: 'customResearch' },
    { label: 'Market Map', value: 'marketMap' },
    { label: 'Deal History', value: 'dealHistory' },
  ],
  projectDateOptions: [
    { label: 'All', value: '' },
    { label: 'Last 2 weeks', value: '14' },
    { label: 'Last 3 months', value: '90' },
    { label: 'Last year', value: '365' },
    // { label: 'Custom', value: 'custom' }, // temporarily disabled
  ],
  projectSortOptions: [
    { label: 'Request date, recent first', value: '-createdAt' },
    { label: 'Request date, oldest first', value: 'createdAt' },
    { label: 'Last update date', value: '-updatedAt' },
    // { label: 'Flagged first', value: '-comments.isUrgent' }, // temporarily disabled
    { label: 'Status', value: '-status' },
    { label: 'Title A-Z', value: '_data.displayName' },
    { label: 'Title Z-A', value: '-_data.displayName' },
    { label: 'Type', value: 'projectType' },
  ],
  ayafOptions: [
    { name: 'Early Start-ups (0-3 years)', value: 'startup' },
    { name: 'Matured Start-ups (above 3 years)', value: 'matured' },
    { name: 'Women Empowered Businesses (WEBs)', value: 'women' },
  ],
  equityOptions: [
    { label: 'Growth Capital', value: 'growth' },
    { label: 'Secondary', value: 'secondary' },
    { label: 'Both', value: 'both' },
  ],
  finsoughtOptions: [
    { label: 'Under $1m', value: '00000_00001' },
    { label: '$1m - $5m', value: '00001_00005' },
    { label: '$5m - $20m', value: '00005_00020' },
    { label: '$20m - $100m', value: '00020_00100' },
    { label: 'Over $100m', value: '00100_99999' },
  ],
  tradeCycleOptions: [
    { label: '< 60 days' },
    { label: '60 - 120 days' },
    { label: '120 - 180 days' },
    { label: '180 - 210 days' },
    { label: '> 210 days' },
  ],
  transactionRoleOptions: [
    { label: 'Business owner / Majority Shareholder' },
    { label: 'Promoter and/or Sponsor' },
    { label: 'Advisor' },
    { label: 'Technical Partner' },
    { label: 'Management/Director' },
    { label: 'Investor and/or Lender' },
  ],
  transactionFrequencyOptions: [
    { label: 'Weekly' },
    { label: 'Monthly' },
    { label: 'Quarterly' },
    { label: 'Once-off' },
  ],
  repaymentSourceOptions: [
    { label: 'Letter of Credit' },
    { label: 'Documents on Collection' },
    { label: 'Credit insured receivables' },
    { label: 'Other' },
  ],
  initiativeTypeOptions: {
    financing: [
      { label: 'Equity ', value: 'equity' },
      { label: 'Debt', value: 'debt' },
      { label: 'Trade', value: 'trade' },
      { label: 'Project', value: 'project' },
    ],
    benchmarking: [
      { label: 'ESG', value: 'esg' },
      { label: 'Operational', value: 'operational' },
      { label: 'Compliance', value: 'compliance' },
    ],
    growth: [
      { label: 'Importing', value: 'importing' },
      { label: 'Exporting', value: 'exporting' },
      { label: 'Logistics ', value: 'logistics' },
      { label: 'Research and development', value: 'research' },
      { label: 'Recruitment', value: 'recruitment' },
      { label: 'By Acquisition', value: 'acquisition' },
      { label: 'Partnership', value: 'partnership' },
      { label: 'Consultation', value: 'consultation' },
    ],
  },
  climateOptions: [
    {
      name: 'Sustainable agriculture and forestry',
    },
    { name: 'Carbon and Waste Management' },
    { name: 'Energy Efficiency' },
    { name: 'Climate adaptation' },
  ],
  infrastructureOptions: [
    {
      name: 'Telecommunications (ICT)',
    },
    {
      name: 'Transportation - Roads',
    },
    {
      name: 'Transportation -  Ports',
    },
    {
      name: 'Transportation -  Bridges',
    },
    {
      name: 'Transportation -  Tunnels',
    },
    {
      name: 'Transportation -  Water ways',
    },
    {
      name: 'Transportation -  Public Transportation',
    },
    {
      name: 'Renewable Energy - Generation of Renewable energy',
    },
    {
      name: 'Renewable Energy - Transmission',
    },
    {
      name: 'Renewable Energy - Distribution',
    },
    {
      name: 'Sanitation - Water supply',
    },
    {
      name: 'Sanitation - Irrigation',
    },
    {
      name: 'Sanitation - Wastewater',
    },
    {
      name: 'Sanitation - Waste',
    },
    {
      name: 'Education - Community Centres',
    },
    {
      name: 'Education - Kindergarten',
    },
    {
      name: 'Education - Schools',
    },
    {
      name: 'Education - Universities',
    },
    {
      name: 'Public Facilities',
    },
  ],
  healthcareOptions: [
    { name: 'Hospital and clinics - Decentral healthcare stations' },
    { name: 'Hospital and clinics - Hospitals' },
    { name: 'Pharmaceutical Companies' },
    { name: 'Laboratories and Diagnostic Centers' },
    { name: 'Telemedicine/Digital Health Companies' },
    { name: 'Mental health and well being ' },
  ],
}
